import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import * as makers from "../service/makers";
import { ServiceTemplateStatus } from "./model";
import { BillingTriggerType } from "../../types/api.model";
export function makeServiceTemplate(input) {
  return {
    id: input.id != null ? input.id : generateUniqueId('service-template'),
    name: input.name,
    description: input.description,
    status: input.status || ServiceTemplateStatus.Active,
    cost: input.cost,
    billing: input.billing,
    integratedId: input.integratedId != null ? input.integratedId : null,
    origin: input.origin || null
  };
}
export const makePercentDiscount = makers.makePercentDiscount;
export const makeValueDiscount = makers.makeValueDiscount;
export const makeFixedCost = makers.makeFixedCost;
export const makeVariableCost = makers.makeVariableCost;
export const makeRangeCost = makers.makeRangeCost;
export function makeBillingOnApproval() {
  return {
    trigger: BillingTriggerType.OnApproval
  };
}
export function makeBillingOneTimeManual() {
  return {
    trigger: BillingTriggerType.OneTimeManual
  };
}
export function makeBillingOneTimeDelivery() {
  return {
    trigger: BillingTriggerType.OneTimeDelivery
  };
}
export function makeBillingOngoing(recurrencePeriod) {
  return {
    trigger: BillingTriggerType.Ongoing,
    recurrencePeriod
  };
}
export function makeBillingRepeatableManual(recurrencePeriod) {
  return {
    trigger: BillingTriggerType.RepeatableManual,
    recurrencePeriod
  };
}